import React from "react";
import Joi from "joi-browser";
import Form from "../../../../common/Form";
import { TextInput } from "../../../../common/inputs/textInput/textInput";
import Entity from "../../../services/entityService";
import EntityContext from "../../../../../context/entityContext";
import RoleChecker from "../../../../../utils/roleChecker";
import { Modal } from "react-bootstrap";
import LoadingSpinner from "../../../../common/loaders/loadingSpinner";
import { toast } from "react-toastify";
import { Link } from "react-router";
import documentService from "../../../../../services/documentService";

class Confirmation extends Form {

  static contextType = EntityContext;

  constructor(props) {
    super(props);
  }

  state = {
    data: {
      termsConditions: true,
      business_name: "",
      email: "",
      first_name: "",
      last_name: "",
      signature: "",
    },
     showTermsModal: false,
     termsDocument: null,
     termsLoading: false,

  };


  schema = Joi.object()
    .keys({
      signature: Joi.string().required().label("Digital Signature"),
      termsConditions: Joi.string()
        .valid(true)
        .required()
        .label("Terms & Conditions"),
    })
    .unknown(true);
  componentDidMount() {
    this.confirmation();
  }


  confirmation = async () => {
    const data = { ...this.state.data };
    const { success, message, user } = await Entity.getLoginedUserDetails();
    if (user) {
      data["business_name"] = user.organization;
      data["email"] = user.email;
      data["first_name"] = user.first_name;
      data["last_name"] = user.last_name;
      data["signature"] = this.state.data.signature;
    }
    this.setState({ data });

  };
  chnageConfirmation = async () => {
    const data = { ...this.state.data };
    data["confirmation"] = false;
    this.setState({ data });
  };
  onCloseModal = () => {
    this.setState({ open: false, selectedFeeType: [] });
  };
  setValues(selectedItem, input) {
    const data = { ...this.state.data };
    data[input] = selectedItem;
    this.setState({ data });
  }

  handleCheckboxChange = (event) => {
    const data = { ...this.state.data };
    data["termsConditions"] = event.target.checked;
    this.setState({ data });
    console.log(event.target.checked);
  };

  openTermsModal = async () => {
    this.setState({ termsLoading: true });

    const { constants, productType } = this.props;

    const facilityCode =
      productType === constants.PRODUCTS.SUPPLYCHAIN
        ? "SCF"
        : productType === constants.PRODUCTS.TRADEFINANCE
        ? "TF"
        : "";

    try {
      const response = await documentService.getTermsDocumentApi({
        facility: facilityCode,
        entity_guid: this.props.entity
      });

      if (!response || response.data?.success !== true) {
        toast.error(response?.data?.message || "Document not found");
        this.setState({ termsLoading: false });
        return;
      }

      this.setState({
        termsDocument: response.data.data,
        showTermsModal: true,
        termsLoading: false
      });
    } catch (e) {
      toast.error("Failed to load document");
      this.setState({ termsLoading: false });
    }
  };

  render() {
    const { data, showTermsModal, termsDocument, termsLoading } = this.state;
      const rateInfo = this.props.rateInfo || {};
      const fixedFee = rateInfo.fixed_fee ?? "N/A";
      const dailyCharge = rateInfo.daily_charge ?? "N/A";
      const totalInterest = rateInfo.total_interest ?? "N/A";
    return (
      <React.Fragment>
        {(this.props.category == this.props.constants.CATEGORY.TRADERS && (RoleChecker.check(this.props.products, this.props.constants.ROLES.CUSTOMER) || RoleChecker.check(this.props.products, this.props.constants.ROLES.TFCUSTOMER )) ) && (
          <>
            <div className="scrollable-div">
              {/* <p  className ="opacity-75">
              The person who clicks 'I AGREE' below represents and warrants that he or she is the "Authorised Person"; specified above, is an "Authorised Person" as defined in the Customer Terms and Conditions and has the Customer's authority to bind the Customer.
              </p>
              <p className ="opacity-75">
              If the "Revised Due Date"3 is equal to the "Invoice Due Date"2 specified above the Customer will pay the "Approved Amount"1 above to Fifo on the 'Invoice Due Date"2 specified above.
              If the "Revised Due Date"3 is different to the "Invoice Due Date"2 specified above the Customer requests that it be allowed to pay on the "Revised Due Date"3 instead of the "Invoice Due Date"2 specified above. If Fifo agrees to that request the Customer will pay the "Total Amount to Pay"4 to Fifo. This amount is the "Approved Amount"1 specified above plus any "Late Payment Fee". Fifo's agreement will be shown by the status of the invoice changing on STREAM from "Awaiting Approval" to "Approved and Purchased".
              The Customer will pay the applicable amount to Fifo in full and without any counterclaim or set-off. The Customer must comply with the Customer Terms and Conditions and has the Customer's authority to bind the Customer and, in particular, confirms each of the items listed in clause 2.3, subject only to the above.
              </p> */}
              <h6>Interest rate on overdue money</h6>

              <p className="opacity-75">
                In addition to your obligations in relation to the “Interest rate on overdue money” as agreed in the Customer Terms and Conditions, you agree to pay interest on any overdue amount, which will consist of:
              </p>

              <ul className="opacity-75">
                <li>a fixed fee of {fixedFee === "N/A" ? "N/A" : `${fixedFee}%`} and</li>
                <li>a daily charge of {dailyCharge === "N/A" ? "N/A" : `${dailyCharge}%`} per day,</li>
              </ul>

              <p className="opacity-75">
                in each case to the extent such amounts exceed the interest you are obliged to pay under the Customer Terms and Conditions.
              </p>

              <h6>Late Payment Fee</h6>

              <p className="opacity-75">
                The Late Payment Fee is calculated for any transaction on Fifopay without having regard to any offer letter.
              </p>

              <p className="opacity-75">
                Note that the figure inserted as {totalInterest === "N/A" ? "N/A" : `${totalInterest}%`} is the total Interest rate on overdue money percentage.
              </p>

              <h6>Authority</h6>

              <p className="opacity-75">
                We have reviewed the Terms and Conditions of the Supply Chain Finance facility and Trade Finance facility and confirm the following:
              </p>

              <p className="opacity-75 fw-semibold">
                Supply Chain Finance Customer Terms &amp; Conditions
              </p>

              <p className="opacity-75">
                “Authorised Person” means the person who has access to Fifopay in accordance with clause 3.3. Clause 3.4 provides that the Customer is responsible for and is bound by everything an Authorised Person does on Fifopay.
              </p>

              <p className="opacity-75 fw-semibold">
                Trade Finance Facility Terms &amp; Conditions
              </p>

              <p className="opacity-75">
                “Authorised Person” means the person who has access to Fifopay and Fifo Technology in accordance with clause 4.3. Clause 4.4 provides that the Customer is responsible for and is bound by everything an Authorised Person does using Fifopay and Fifo Technology.
              </p>

              <p className="opacity-75">
                Accordingly, any finance manager or person who has access to the portal is an Authorised Person under the relevant deed, and the Customer is bound to the new rates upon the Authorised Person clicking "I agree".
              </p>

              {/* <p className="opacity-75">
                Please refer to your <a href="https://central.fifostage.com/" target="_blank">Terms and Conditions</a> 
              </p> */}
              <p className="opacity-75">
                Please refer to your &nbsp;
                <Link onClick={this.openTermsModal} className="text-primary cursor-pointer">
                  Terms and Conditions
                </Link>
              </p>

            </div>


            <div class="custom-control d-flex custom-checkbox mt-4">
              <input
                id={`customCheck1`}
                type="checkbox"
                className="custom-control-input"
                name="checkconfirm"
                onChange={e => this.handleCheckboxChange(e)}
                checked={data.termsConditions ? true : false}
              // disabled={itemRole.isDisabled ? itemRole.isDisabled : false}
              />
              <label class="custom-control-label" for={`customCheck1`}>
                {/* I, {data.first_name} {data.last_name} confirms that: */}
                I AGREE.
              </label>
            </div>

            <div className="  text-xs my-3 text-danger">
              <p>AS A DIGITAL SIGNATURE TO CONFIRM YOUR UNDERSTANDING OF AND AGREEMENT TO OUR TERMS AND CONDITIONS, TYPE YOUR FIRST AND LAST NAME HERE AS A LEGALLY BINDING ELECTRONIC SIGNATURE.*</p>
              {/* <p>TYPE YOUR FIRST AND LAST NAME HERE AS A LEGALLY BINDING ELECTRONIC SIGNATURE</p> */}
            </div>
            <div className="form-group">
              <TextInput name="signature" value={data.signature} label="Signature" reference={this.signature} onChange={this.handleChange} type="" ></TextInput>
            </div>
          </>
        )}


        {((this.props.category == this.props.constants.CATEGORY.BP || this.props.category == this.props.constants.CATEGORY.COUNTRY_OFFICE || this.props.category == this.props.constants.CATEGORY.INTL_OFFICE)) && (
          <>
            {/* <div>


              <h6>Acknowledgement</h6>

              <p className="opacity-75">I am responsible for this Client and their Supplier, I agree that by adding this invoices and clicking the ‘submit’ button that I have received the invoice from the Client and I am held responsible for paying the Supplier as instructed by the Client.
                If I have not received this invoice, I confirm I have suitable confirmation that what I have entered here is correct and under instruction from the Client. I will only pay the Supplier after the Client selects the date they will pay.
              </p>
              <h6>CONFIRMATION*</h6>

              <p className="opacity-75">I have completed all my due diligence on the Client. I have completed all my due diligence on the Supplier. I have completed all my due diligence on the invoice in question and where I deem it necessary, I will complete one final check before making any payment to the Supplier.</p>
            </div> */}
            <div>
              <h6>Interest rate on overdue money</h6>

              <p className="opacity-75">
                In addition to your obligations in relation to the “Interest rate on overdue money” as agreed in the Customer Terms and Conditions, you agree to pay interest on any overdue amount, which will consist of:
              </p>

              <ul className="opacity-75">
                <li>a fixed fee of {fixedFee === "N/A" ? "N/A" : `${fixedFee}%`} and</li>
                <li>a daily charge of {dailyCharge === "N/A" ? "N/A" : `${dailyCharge}%`} per day,</li>

              </ul>

              <p className="opacity-75">
                in each case to the extent such amounts exceed the interest you are obliged to pay under the Customer Terms and Conditions.
              </p>

              <h6>Late Payment Fee</h6>

              <p className="opacity-75">
                The Late Payment Fee is calculated for any transaction on Fifopay without having regard to any offer letter.
              </p>

              <p className="opacity-75">
                Note that the figure inserted as {totalInterest === "N/A" ? "N/A" : `${totalInterest}%`} is the total Interest rate on overdue money percentage.
              </p>

              <h6>Authority</h6>

              <p className="opacity-75">
                We have reviewed the Terms and Conditions of the Supply Chain Finance facility and Trade Finance facility and confirm the following:
              </p>

              <p className="opacity-75 fw-semibold">
                Supply Chain Finance Customer Terms &amp; Conditions
              </p>

              <p className="opacity-75">
                “Authorised Person” means the person who has access to Fifopay in accordance with clause 3.3. Clause 3.4 provides that the Customer is responsible for and is bound by everything an Authorised Person does on Fifopay.
              </p>

              <p className="opacity-75 fw-semibold">
                Trade Finance Facility Terms &amp; Conditions
              </p>

              <p className="opacity-75">
                “Authorised Person” means the person who has access to Fifopay and Fifo Technology in accordance with clause 4.3. Clause 4.4 provides that the Customer is responsible for and is bound by everything an Authorised Person does using Fifopay and Fifo Technology.
              </p>

              <p className="opacity-75">
                Accordingly, any finance manager or person who has access to the portal is an Authorised Person under the relevant deed, and the Customer is bound to the new rates upon the Authorised Person clicking "I agree".
              </p>

              <p className="opacity-75">
                Please refer to your &nbsp;
                <Link onClick={this.openTermsModal} className="text-primary cursor-pointer">
                  Terms and Conditions
                </Link>
              </p>
            </div>


            <div class="custom-control d-flex custom-checkbox">
              <input
                id={`customCheck1`}
                type="checkbox"
                className="custom-control-input"
                name="checkconfirm"
                onChange={e => this.handleCheckboxChange(e)}
                checked={data.termsConditions ? true : false}
              // disabled={itemRole.isDisabled ? itemRole.isDisabled : false}
              />
              <label class="custom-control-label" for={`customCheck1`}>
                I, {data.first_name} {data.last_name} confirm that:
              </label>
            </div>
            <div className="  text-xs my-3 text-danger">

              <p>USING MY DIGITAL SIGNATURE I AGREE WITH THE ABOVE ACKNOWLEDGEMENT AND CONFIRMATION</p>
              <p>TYPE YOUR FIRST AND LAST NAME HERE AS A LEGALLY BINDING ELECTRONIC SIGNATURE</p>
            </div>

            <div className="form-group">
              <TextInput name="signature" value={data.signature} label="Signature" reference={this.signature} onChange={this.handleChange} type="" ></TextInput>
            </div>
          </>
        )}

        <Modal
          show={showTermsModal}
          onHide={() => this.setState({ showTermsModal: false })}
          size="xl"
        >
          <Modal.Header closeButton>
            <Modal.Title>Terms & Conditions</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {termsLoading ? (
              <LoadingSpinner />
            ) : (
              
              <iframe
                src={termsDocument?.view_url}
                style={{ width: "100%", height: 600 }}
                title="Terms and Conditions"
              />
            )}
          </Modal.Body>

          <Modal.Footer>
            <button
              className="btn btn-light"
              onClick={() => this.setState({ showTermsModal: false })}
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>



      </React.Fragment >
    );
  }
}
Confirmation.contextType = EntityContext;
export default Confirmation;